Apt.fn.make('newsletter', {
	/**
	 * Initialize module
	 */
	init: function() {
		// Fetch the form we want to deal with
		let $formContainer = $$('footer-newsletter');
		let formId = $formContainer.data('form-id');
		let formHandle = $formContainer.data('form-handle');
		let $form = $formContainer.find(`#${formId}`);

		// Find the CSRF token hidden input, so we can replace it
		let $csrfInput = $form.find('input[name="CRAFT_CSRF_TOKEN"]');

		// Fetch the new token for the form and replace the CSRF input with our new one
		fetch(`/actions/formie/forms/refresh-tokens?form=${formHandle}`)
			.then(result => { return result.json(); })
			.then(result => {
				if ($csrfInput) {
					$csrfInput.val(result.csrf.token);
				}

				// Find the JavaScript captcha hidden input, so we can update it
				if (result.captchas && result.captchas.javascript) {
					// JavaScript captcha
					let jsCaptcha = result.captchas.javascript;

					$form.find('input[name="' + jsCaptcha.sessionKey + '"]').val(jsCaptcha.value);
				}

				// Find the Duplicate captcha hidden input, so we can update it
				if (result.captchas && result.captchas.duplicate) {
					// Duplicate captcha
					let duplicateCaptcha = result.captchas.duplicate;

					$form.find('input[name="' + duplicateCaptcha.sessionKey + '"]').val(duplicateCaptcha.value);
				}

				// Update the form's hash (if using Formie's themed JS)
				if ($form.form && $form.form.formTheme) {
					$form.form.formTheme.updateFormHash();
				}

				// Remove existing alerts
				let alerts = $formContainer.find('.fui-alert');
				alerts.each(function($alert) {
					$alert.remove();
				});
			});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('newsletter');
	}
});